import { compose, propEq, find } from 'ramda'

export const getAutoplayThreshold = compose(
  option => parseFloat(option.value),
  find(propEq('key', 'PLAYER_AUTO_PLAY_THRESHOLD'))
)
